import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-emissions-factors-filter',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
  ],
  templateUrl: './emissions-factors-filter.html',
  styleUrl: './emissions-factors-filter.scss',
  providers: [MessageService]
})
export class EmissionsFactorsFilter {

  searchText: string = '';

  filter = output<string>();
  clear = output<void>();

  applyFilters() {
    this.filter.emit(this.searchText.trim());
  }

  clearFilters() {
    this.searchText = '';
    this.filter.emit('');
    this.clear.emit();
  }


}
